// @ts-strict-ignore
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { LMDialogInfo } from '@base/index';

@Component({
  selector: 'lm-dirty-check-form',
  template: `
    <p>{{info.message}}</p>
  `
})

export class LMDirtyCheckDialogComponent implements OnInit, AfterViewInit {
  @Input() info: LMDialogInfo;

  constructor() {
  }

  ngOnInit() {
    // no-op
  }

  ngAfterViewInit() {
    // no-op
  }
}
